module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAUCAIAAABqGAhiAAABF0lEQVRIx2NQcFqIidTcl2AVz7bKvqUrQzZiQDPOInx1fuuh2oknHGLXN087reS8iFaWFXUc8U7bnFG/v3biybTafa5JG5umnlJ1W0x9y3R8lgXnbk+v27/72OO2GafX7Lyzcutt26h1luFrqG+Zgf+KyKKdm/bdn7/uWn774YqeozuPPMps2F/ccYT6lgF90Djl1Ob99+etvVbRf7y87/jeE4+TqvZ0zzlHfcuUXRY5xq3PbTl09fbb8u5jU5Ze3LDnnnHQSqCPaZJAYkp3Ae3LajhQ1Xesqv+4edhqYAIBxiWtkj4wNWY2HGiZdto0eNXERRepnM8MHaZiIgv3mSbO0zHFyyySKbKMEs2jlo1aNmrZCLcMALqjSdeB5lWEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mm.png
// module id = 885
// module chunks = 0